import { useReactiveVar } from '@apollo/client';
import { useTheme } from '@fluentui/react';
import {
    BaseEdge,
    EdgeProps,
    getSmoothStepPath,
    Position
} from '@xyflow/react';
import { setFlowLayoutState } from '../../../Conditions';

// @ts-ignore
export const CloseEdge: React.FC<EdgeProps> = ({
  id,
  sourceX,
  sourceY,
  targetX,
  targetY,
  ...rest
}) => {
  const flowLayoutState = useReactiveVar(setFlowLayoutState);
  const theme = useTheme();
  const [edgePath] = getSmoothStepPath({
    sourceX,
    sourceY,
    targetX,
    targetY,
    targetPosition:
      flowLayoutState === 'horizontal' ? Position.Left : Position.Top,
    sourcePosition:
      flowLayoutState === 'horizontal' ? Position.Right : Position.Bottom,
  });

  return (
    <>
      <BaseEdge
        id={id}
        path={edgePath}
        style={{ stroke: theme.palette.themePrimary, strokeWidth: 2 }}
      />
    </>
  );
};
